<template lang="pug">
v-container.pa-4(style="max-width:600px")
  .text-2xl.font-semibold.mt-2.mb-4 Upload Photo
  template(v-if="isLoading")
    v-skeleton-loader(type="image")
    v-skeleton-loader(type="list-item-two-line@3")
  
  template(v-else)
    template(v-if="isInvalid")
      .mb-1 Sorry, the link has expired or invalid.
      .text-sm.neutral500--text Kindly reopen the 'Attach Photo' on the dashboard page and scan the QR code again.
    
    template(v-else)
      v-card.round-xl.border-dashed.pa-8.mb-4(link outlined)
        .text-center
          v-avatar.mb-3(color="neutral300" size="40")
            v-icon(color="neutral500" size="18") $yzi-image-01
          .mb-1.text-sm Click to upload or drag and drop
          .text-xs.neutral500--text JPG and PNG (max. 4MB)
        input.input-change-layout(ref="file" type="file" @change="onFileChange" accept="image/*")

      template(v-for="photo in databinPhotos")
        v-card.d-flex.pa-2.round-xl.mb-2(outlined)
          .flex-grow-0.mr-4
            v-img(width="40" height="40" :src="$options.filters.smallImage(photo.file)" contain)
          .text-sm.flex-grow-1
            .font-medium {{ photo.filename }}
            .neutral500--text 100% {{ $t('uploaded') }}
          v-icon.ml-4(size="22" color="success") $yzi-check-circle-solid

      template(v-for="photo in photos")
        v-card.d-flex.pa-2.round-xl.mb-2(outlined)
          .flex-grow-0.mr-4
            v-img(width="40" height="40" :src="require('@/assets/image_placeholder.png')" contain)
          .text-sm.flex-grow-1
            .font-medium {{ photo.file.name }}
            .neutral500--text {{ photo.file.size | bytesToSize }} - {{ photo.progress }}% {{ $t('uploaded') }}
          v-progress-circular(size="22" width="3" :value="photo.progress" color="#0D6EFF")

</template>

<script>
import { mapActions } from 'vuex'
// import { resizeImage } from '@/utils'
import { fixImageOrientation } from '@/utils'

export default {
  name: 'UploadPhoto',
  props: ['databinKey'],
  data: () => ({
    isLoading: false,
    isInvalid: false,
    photos: [],
    databinPhotos: [],
    polling: null
  }),
  mounted () {
    this.fetchDatabin()
  },
  methods: {
    ...mapActions(['showMessage']),
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      // const resizedImage = await resizeImage(files[0], `photo_${Date.now()}.jpeg`)
      const correctedFile = await fixImageOrientation(files[0])
      const photo = {
        data: null,
        file: correctedFile,
        progress: 0
      }
      this.photos.push(photo)
      this.uploadPhoto(photo)
    },
    uploadPhoto (photo) {
      const formData = new FormData()
      formData.append('file', photo.file)
      this.$axios.post(`/documents/`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: progressEvent => (photo.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total))
        })
        .then(resp => {
          const uploadedPhoto = resp.data
          this.uploadToDatabin(uploadedPhoto)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    fetchDatabin () {
      this.isLoading = true
      this.$axios.get(`/databin/${this.databinKey}`)
        .then(resp => {
          if (JSON.stringify(resp.data) !== '{}') {
            this.databinPhotos = resp.data
          }
          this.startPolling()
        })
        .catch(() => {
          this.isInvalid = true
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    refreshDatabin () {
      this.$axios.get(`/databin/${this.databinKey}`)
        .then(resp => {
          if (JSON.stringify(resp.data) !== '{}') {
            this.databinPhotos = resp.data
          }
        })
        .catch(() => {
          this.isInvalid = true
        })
        .finally(() => {
        })
    },
    uploadToDatabin (photo) {
      const data = [...this.databinPhotos, photo]
      if (this.databinKey) {
        this.$axios.put(`/databin/${this.databinKey}/?ttl=900`, data)
          .then(resp => {
            this.databinPhotos = resp.data.data
            this.photos.pop(photo)
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
      }
    },
    startPolling () {
      this.stopPolling()
      this.polling = setInterval(() => {
        this.refreshDatabin()
      }, 4000)
    },
    stopPolling () {
      clearInterval(this.polling)
    }
  },
  destroyed () {
    this.stopPolling()
  }
}
</script>

<style scoped>
.file-layout {
  position: relative;
  cursor: pointer;
  border: var(--v-neutral400) dashed 1px;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
</style>